/* eslint-disable no-unused-vars */
import {
	mshl7,
	msprogram,
	mstreatment,
	mssmartfit,
	msaccount,
	msaudit,
	mscommons,
	msreports,
	msschedule,
	ms1doc3,
	msnotification,
	mssuscription,
	msclinichistory
} from './microservices'

const url = process.env.REACT_APP_API_ENDPOINT
const urlTransversal = process.env.REACT_APP_TRANSVERSAL

// Account
export const login = ({ userId }) => `${url}${msaccount}/api/v1/authenticate/${userId}`
export const newRegister = `${url}${msaccount}/api/v1/login/register/user`
export const authenticate = `${url}${msaccount}/api/v1/login/authenticate`
export const changePassword = `${url}${msaccount}/api/v1/profile/change-password`
export const profile = ({ userId }) => `${url}${msaccount}/api/v1/profile/${userId}`
export const emailValidation = `${url}${msaccount}/api/v1/user`
export const patient = ({ userId }) => `${url}${msaccount}/api/v1/caregiver/${userId}/patients`
export const userCIS = ({ userId }) => `${url}${msaccount}/api/v1/profile/${userId}/update/cis`
export const updateCareStatus = `${url}${msaccount}/api/v1/update/user`
export const updateUserInfo = ({ userId }) => `${url}${msaccount}/api/v1/profile/${userId}/update`
export const getBenefitsUser = ({ userId, idBenefit }) =>
	`${url}${msaccount}/api/v1/advantage/${userId}?advantage=${idBenefit}`
export const saveBenefitsUser = ({ userId }) => `${url}${msaccount}/api/v1/advantage/${userId}/save`
export const getAddonsAvailables = ({ userId }) => `${url}${msaccount}/api/v1/careshop/${userId}`

export const updateUserOnboardingInitial = ({ userId }) =>
	`${url}${msaccount}/api/v1/profile/${userId}/onboarding`
export const getDocumentType = `${url}${msaccount}/api/v1/document-types/all`
export const getDocumentTypePublic = `${url}${msaccount}/api/v1/public/document-types/all`
export const getDocumentTypesAll = `${mscommons}/api/v1/public/document-types`
export const updateOnboardingPrograms = ({ userId }) =>
	`${url}${msaccount}/api/v1/profile/${userId}/update/onboarding/program`

// Caregiver
export const caregiver = ({ userId, patientId }) =>
	`${url}${msaccount}/api/v1/caregiver/${userId}/remove/${patientId}`

// Clinichistory
export const calculateBMI = `${url}${msclinichistory}/api/v1/public/calculate/bmi`

// Register
export const register = `${url}${msaccount}/api/v1/register/user`

// Treatment
export const devices = ({ userId }) => `${url}${mstreatment}/api/v1/devices/${userId}`
export const treatment = ({ userId }) => `${url}${mstreatment}/api/v1/treatment/${userId}`
export const setTreatment = `${url}${mstreatment}/api/v1/treatment/save`
export const medicine = ({ userId }) => `${url}${mstreatment}/api/v1/medicine/${userId}`
export const deleteMedicine = ({ userId, medicineId }) =>
	`${url}${mstreatment}/api/v1/medicine/${userId}/${medicineId}`
export const treatmentIMC = `${url}${mstreatment}/api/v1/treatment/imc`
export const treatmentSymptoms = ({ userId }) =>
	`${url}${mstreatment}/api/v1/treatment/${userId}/symptoms`
export const saveProcessRequest = ({ userId }) =>
	`${url}${mstreatment}/api/v1/process?userId=${userId}`
// ask home
export const getAsk = ({ userId }) => `${url}${mstreatment}/api/v1/questions/list/${userId}`
export const saveAsk = `${url}${mstreatment}/api/v1/questions/save`

// Symptoms
export const symptoms = `${url}${mstreatment}/api/v1/symptoms`
export const setSymptoms = `${url}${mstreatment}/api/v1/symptoms/save`
export const symptomsGraphic = userId => `${url}${mstreatment}/api/v1/symptoms/${userId}/graphics`

// Reminders
export const reminders = ({ userId }) => `${url}${msnotification}/api/v1/reminders/${userId}`

// Notifications
export const notification = ({ userId }) =>
	`${url}${msnotification}/api/v1/configuration/${userId}/token`

// Vaccination
export const vaccination = `${url}${mstreatment}/api/v1/covid`

// Pathologies
export const pathologies = `${url}${mstreatment}/api/v1/pathology`

// legal
export const legal = `${urlTransversal}/legal/api/v1/legal`
export const updateLegal = ({ userId }) =>
	`${url}${msaccount}/api/v1/profile/${userId}/update/legal`
export const updateLegalLogin = ({ userId }) => `${url}${msaccount}/api/v1/login/${userId}/legal`
export const updateLegalParQCareCenter = ({ userId }) =>
	`${url}${msaccount}/api/v1/parq/${userId}/legal`
export const updateLegalSmartfit = `${url}${mssmartfit}/api/v1/parq/update/legal/documents`
export const getLegalParQCareCenter = ({ userId }) =>
	`${url}${mscommons}/api/v1/public/parq/${userId}/legal`

// tool
export const tool = `${url}${mstreatment}/api/v1/tools/save`
export const getToolDiabetes = `${url}${mstreatment}/api/v1/questions/findrisc/diabetes/get`
export const saveToolDiabetes = `${url}${mstreatment}/api/v1/questions/findrisc/diabetes/save`

// plan
export const plan = `${url}${msprogram}/api/v1/plan`
export const activePlan = `${plan}/activate`
export const getChallengePlan = `${plan}/challenges`
export const getChallengeById = challengeId => `${plan}/challenge?challengeId=${challengeId}`
export const getProgress = `${plan}/progress`
export const activityComplete = `${plan}/activity/complete`
export const medical = `${plan}/medical/guidance`
export const onboard = `${plan}/onboarding`

// contentFull elasticSearch
export const elastic = `${url}${msreports}/api/v1`
export const elasticPlan = `${elastic}/vital/plan`
export const elasticPlanGeneral = `${elastic}/general/plan`

// tracking
export const tracking = ({ userId }) => `${url}${msaccount}/api/v1/tracking/campaign/${userId}`

// parQ
export const setParQ = ({ userId }) => `${url}${mscommons}/api/v1/public/parq/${userId}/save`
export const setParQSmartfit = `${url}${mssmartfit}/api/v1/parq/save`

// entry parQ
export const firstEntry = ({ userId }) =>
	`${url}${msaccount}/api/v1/profile/${userId}/validate/parqs`

// parQPublic
export const getParQPublicUser = ({ userId }) => `${url}${msaccount}/api/v1/profile/${userId}`
export const getParQPublicSmartFit = `${url}${mssmartfit}/api/v1/parq/register/user`

// shortcuts
export const shortcuts = ({ userId }) => `${url}${mscommons}/api/v1/quick/${userId}/access`

// appointment
export const getMyAppointment = ({ userId }) => ''
export const getUserAppointment = ({ userId }) => ''
export const getAppointments = ({ userId }) => ''
export const setAppointment = ({ userId }) => ''
export const setAppointmentPhysiotherapy = ({ userId }) => ''
export const deleteAppointment = ({ userId }) => ''
// commons
export const getToday = `${url}${mscommons}/api/v1/today`
export const getAllyRegister = ({ userId }) => `${url}${mscommons}/api/v1/ally/get/${userId}`
export const sendUserKutaiRegister = `${url}${mscommons}/api/v1/ally/register/user`
export const getKutaiPrograms = `${url}${mscommons}/api/v1/public/kutai/programs`
export const sendUserAllyRegister = ({ userId }) =>
	`${url}${mscommons}/api/v1/ally/register/${userId}`
export const getSurvey = ({ code, userId }) =>
	`${url}${mscommons}/api/v1/public/survey/${code}?userId=${userId}`
export const setSurvey = `${url}${mscommons}/api/v1/public/survey/user`
export const getResultsSurvey = `${url}${mscommons}/api/v1/public/survey/user`
export const checkUserSurvey = ({ numberDocument, documentType }) =>
	`${url}${mscommons}/api/v1/public/survey/user/${numberDocument}?documentType=${documentType}`
export const registerUserSurvey = `${url}${mscommons}/api/v1/public/survey/user/register`
export const getUrlFileS3 = ({ fileName }) =>
	`${url}${mscommons}/api/v1/pre-signed-url?fileName=${fileName}`
export const getSurveyOptions = `${url}${mscommons}/api/v1/public/survey/groups`
export const getFamilyRelationships = `${url}${mscommons}/api/v1/public/family-hr`
export const getBiologicalSex = `${url}${mscommons}/api/v1/public/biological-sex`
export const getDepartments = `${url}${mscommons}/api/v1/public/departments`
export const getCitiesByDepartment = `${url}${mscommons}/api/v1/public/cities`
export const getCareCentersList = `${url}${mscommons}/api/v1/public/parq-centers`

// challenge | habits
export const getHabits = ({ userId }) => `${url}${mscommons}/api/v1/habits/${userId}/favorites`
export const postHabitsFavorites = `${url}${mscommons}/api/v1/habits/favorites`
export const setHabitsFavorites = `${url}${mscommons}/api/v1/habits/favorites`
export const setChallengeDone = ({ userId }) => `${url}${mscommons}/api/v1/mark/${userId}/challenge`
export const getMarkedTip = ({ userId }) => `${url}${mscommons}/api/v1/mark/${userId}/tips`
export const markTip = ({ userId }) => `${url}${mscommons}/api/v1/mark/tips/${userId}`
export const setNPS = ({ userId }) => `${url}${mscommons}/api/v1/nps/${userId}/save`

// subscription
export const setSubscription = `${url}${mssuscription}/api/v1/create`
export const saveSubscriptionUser = ({ userId }) =>
	`${url}${mssuscription}/api/v1/carenetwork/${userId}/save/service`
export const getUserServices = ({ userId }) =>
	`${url}${mssuscription}/api/v1/carenetwork/${userId}/get`
export const deleteServices = ({ userId }) =>
	`${url}${mssuscription}/api/v1/carenetwork/${userId}/cancel/service`
export const getInfoSubscription = ({ userId }) =>
	`${url}${mssuscription}/api/v1/get/${userId}/info`

// lives
export const getLives = ({ userId }) => ''
export const getAllLives = ({ userId }) => ''
export const setLiveReserve = ({ userId }) => ''
export const deleteLiveReserve = ({ userId, meetingId }) => ''
// notifications
export const notifications = ({ userId }) => `${url}${msnotification}/api/v1/${userId}`
export const notificationsConfig = ({ userId }) =>
	`${url}${msnotification}/api/v1/configuration/${userId}`

// classes
export const getClasses = ({ userId }) => ''
export const getClassesById = ({ userId }) => ''
export const getLessons = ({ userId }) => ''
export const getPopularClasses = ({ userId }) => ''
export const reserveClasses = ({ userId }) => ''
export const cancelClasses = ({ userId }) => ''
export const getClassesCycling = ({ userId }) => ''

// lessons
export const getCurrentLesson = ({ userId }) => ''

// search
export const searchGet = `${url}${msreports}/api/v1/search/tools`

// QR Care center
export const markLesson = ({ userId }) => ''

// audit
export const getEvent = `${url}${msaudit}/api/v1/events`
export const saveEventRegistry = ({ userId }) => `${url}${msaudit}/api/v1/event/${userId}/save`

// programs
export const getAllUnSuscribePrograms = ({ userId }) => `${url}${msprogram}/api/v1/${userId}/all`
export const getUserPrograms = ({ userId }) => `${url}${msprogram}/api/v1/user/${userId}/all`
export const setProgramUser = `${url}${msprogram}/api/v1/user/add`
export const updateProgram = `${url}${msprogram}/api/v1/user/update`

export const getActivities = ({ userId }) => `${url}${msprogram}/api/v1/item/user/${userId}/get`
export const updateActivities = ({ userId }) =>
	`${url}${msprogram}/api/v1/item/user/${userId}/update-list`
// 1doc3
export const getLinkTool = ({ userId, tool }) =>
	`${url}${ms1doc3}/api/v1/generate/${userId}?tool=${tool}`
export const saveRecommendation = ({ userId }) => `${url}${mshl7}/api/v1/illnes-note/save/${userId}`
